module.exports = __webpack_public_path__ + "37ba7b92/img/placeholder.888fcd0b.svg";